import * as React from "react";

function SvgLibrato(props, ref) {
  return (
    <svg
      id="Librato_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 55.3 44.5"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Librato_svg__st0{fill:#262626}"}</style>
      <path
        className="Librato_svg__st0"
        d="M26.3 20.9l.5-.1c3.5-1.1 7-2.3 10.4-3.8 3.4-1.4 6.7-3.2 9.6-5.5C49.9 9 52.2 5.7 53.5 2c.3-.6.5-1.3.6-2-4.7 6.4-23.2 7-23.2 7l4.4-4c-12.6.1-25 4.1-35.3 11.5 7 .7 13.5 3.7 18.8 8.4 2.4-.8 5-1.3 7.5-2M55.3 20.2c-11.8-.6-23.5.9-34.8 4.4 2.4 2.5 4.3 5.3 5.8 8.3 9.4-5.2 22.3-11.7 29-12.7M27.6 35.7c1.1 2.8 1.8 5.8 2.1 8.8l16.2-16.7-18.3 7.9"
      />
    </svg>
  );
}

export default React.forwardRef(SvgLibrato);
